/** @jsx jsx */
import { Box, FileEntry, FileEntryMode, FileEntryProps, Flex } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

export interface InProgressFileEntryProps
  extends Omit<FileEntryProps, "ariaLabelCancel" | "ariaLabelDelete" | "ariaLabelDownload" | "ariaLabelRemove"> {
  attachment: File;
}

export const InProgressFileEntry: FC<InProgressFileEntryProps> = ({ attachment, ...fileEntryProps }) => {
  const { t } = useTranslation(["public", "common"]);

  return (
    <Flex>
      <Box sx={{ maxWidth: "100%" }} flexGrow={1}>
        <FileEntry
          ariaLabelCancel={t("COMPONENTS.FILE_UPLOAD.CANCEL")}
          ariaLabelDelete={t("COMPONENTS.FILE_UPLOAD.DELETE")}
          ariaLabelRemove={t("COMPONENTS.FILE_UPLOAD.DELETE")}
          ariaLabelDownload={t("COMPONENTS.FILE_UPLOAD.DOWNLOAD")}
          mode={FileEntryMode.EDIT}
          file={attachment}
          {...fileEntryProps}
        />
      </Box>
    </Flex>
  );
};
